import founder from "@/assets/founder-headshot-t.png";

export default function FounderFrame({ className = "" }) {
  return (
    <div className={`relative ${className}`} data-testid="founder-headshot-frame">
      <div className="absolute -left-4 -top-4 h-full w-full rounded-[2rem] border border-bluerule/70" />
      <span className="absolute -right-3 -top-4 font-mono text-lg text-line">+</span>
      <span className="absolute -bottom-4 -left-3 font-mono text-lg text-line">+</span>
      <div className="relative overflow-hidden rounded-[2rem] border border-line bg-parchment shadow-[0_40px_80px_-50px_rgba(31,28,25,0.4)]">
        <img
          src={founder}
          alt="Gary, Founder of Transactr"
          data-testid="founder-headshot-img"
          className="h-full w-full object-cover"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-coal/30 via-transparent to-transparent" />
        <div className="absolute left-5 top-5 rounded-full border border-line bg-paper/90 px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-ink backdrop-blur">
          Founder · Transactr
        </div>
      </div>
    </div>
  );
}
